import React, { useState } from "react";
import Layout from "../components/Layout/Layout";
import "./css/Terms.css";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setActiveButton } from "../redux/features/footerMenuSlice";
import HeroSvg from "../components/Layout/HeroSvg";
import {
  ChevronLeftSvg,
  ListSvg,
} from "../components/AllSvgModulesExport/LoginSvg";

const RefundPolicy = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [sideMenu, setSideMenu] = useState(false);

  const onClose = () => {
    dispatch(setActiveButton("home"));
    navigate("/");
    localStorage.setItem("activeButton", "home");
  };

  return (
    <Layout>
      <div className="d-none d-lg-block">
        <section className="bg-heading">
          <h4>
            <b>Refund Policy</b>
          </h4>
        </section>
        <section className="terms-container">
          <h5>Refund Eligibility</h5>
          <p>
            - Refunds will not be processed if incorrect details are provided.
          </p>

          <h5 className="">Valid Reasons for Refunds</h5>
          <p>
            - Refunds will be considered for unauthorized transactions,
            technical issues causing non-delivery of in-game items, or other
            verifiable errors.
          </p>

          <h5 className="">Refund Process</h5>
          <p>
            - Users should submit refund requests via our customer support email
            at <b>coinssups@gmail.com</b>.
          </p>
          <p>
            - Provide the transaction details, including the order number, date
            of purchase, and a detailed explanation of the issue.
          </p>

          <h5 className="">Refund Approval</h5>
          <p>
            - Refunds are subject to approval and may require investigation.
          </p>
          <p>
            - We reserve the right to refuse a refund if the request is beyond
            the specified refund period or if we determine the purchase was not
            made in good faith.
          </p>

          <h5 className="">Refund Methods</h5>
          <p>
            - Approved refunds will be processed using the original payment
            method.
          </p>
          <p>
            - In certain cases, alternative refund methods may be considered.
          </p>

          <h5 className="">Non-Refundable Items</h5>
          <p>
            - Certain in-game items or services may be non-refundable. Users are
            advised to check product descriptions before making a purchase.
          </p>

          <h5 className="">Chargebacks</h5>
          <p>
            - Users are encouraged to contact us for resolution before
            initiating any chargebacks. Chargebacks may result in the suspension
            of accounts.
          </p>

          <h5 className="">Policy Changes</h5>
          <p>
            - We reserve the right to update or modify the refund policy at any
            time. Users will be notified of any changes.
          </p>

          <p>
            <i>
              By using our website and making in-game purchases, users
              acknowledge and agree to abide by this refund policy.
            </i>
          </p>
        </section>
      </div>
      <div className={`account-modal-container d-lg-none d-md-none `}>
        <HeroSvg />
        <div className="account-modal-container-content">
          <div className="top-left-content">
            <div className="box-1 center" onClick={onClose}>
              <ChevronLeftSvg />
            </div>
            <h2 className="mb-0">Terms & conditions</h2>
          </div>
          <div
            className="top-right-content box-2 center"
            onClick={() => setSideMenu(!sideMenu)}
          >
            <ListSvg />
          </div>
        </div>
        <div className="terms-mobile-container">
          <section>
            <h5>Refund Eligibility</h5>
            <p>
              - Refunds will not be processed if incorrect details are provided.
            </p>

            <h5 className="">Valid Reasons for Refunds</h5>
            <p>
              - Refunds will be considered for unauthorized transactions,
              technical issues causing non-delivery of in-game items, or other
              verifiable errors.
            </p>

            <h5 className="">Refund Process</h5>
            <p>
              - Users should submit refund requests via our customer support
              email at <b>coinssups@gmail.com</b>.
            </p>
            <p>
              - Provide the transaction details, including the order number,
              date of purchase, and a detailed explanation of the issue.
            </p>

            <h5 className="">Refund Approval</h5>
            <p>
              - Refunds are subject to approval and may require investigation.
            </p>
            <p>
              - We reserve the right to refuse a refund if the request is beyond
              the specified refund period or if we determine the purchase was
              not made in good faith.
            </p>

            <h5 className="">Refund Methods</h5>
            <p>
              - Approved refunds will be processed using the original payment
              method.
            </p>
            <p>
              - In certain cases, alternative refund methods may be considered.
            </p>

            <h5 className="">Non-Refundable Items</h5>
            <p>
              - Certain in-game items or services may be non-refundable. Users
              are advised to check product descriptions before making a
              purchase.
            </p>

            <h5 className="">Chargebacks</h5>
            <p>
              - Users are encouraged to contact us for resolution before
              initiating any chargebacks. Chargebacks may result in the
              suspension of accounts.
            </p>

            <h5 className="">Policy Changes</h5>
            <p>
              - We reserve the right to update or modify the refund policy at
              any time. Users will be notified of any changes.
            </p>

            <p>
              <i>
                By using our website and making in-game purchases, users
                acknowledge and agree to abide by this refund policy.
              </i>
            </p>
          </section>
        </div>
      </div>
    </Layout>
  );
};

export default RefundPolicy;
